<template>
  <div class="popup-overlay" @click.self="$emit('close')">
    <div class="popup-content">
      <div class="modal-header transparent">
        <div class="giga-page_header">
          <h2 class="giga-page_title">
            Votre Application Gigawhat est mise à jour !
            <span class="version-green">{{ note.version }}</span>
          </h2>
        </div>

        <button @click="$emit('close')">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="news">
          <img
              class="news-icon"
              src="@/assets/images/icons/news.png"
              alt="News"
          />
          Nouveautés
        </div>

        <div class="border-gradient">
          <div class="frame-content">
          <div class="release-header">
            <div class="release-left">
              <span class="giga-release">Gigawhat</span>
              <span class="version-green">V{{ note.version }}</span>
            </div>
            <span class="release-date">{{ note.date }}</span>
          </div>

          <!-- SECTIONS -->
          <div class="section" v-if="note.featureNotes.length">
            <div class="section-header">
              <img
                  class="icon"
                  src="@/assets/images/icons/new_fonctionality.svg"
                  alt="NEW_FEATURES"
              />
              <span class="section-title">Nouvelles fonctionnalités</span>
            </div>
            <ul class="section-content">
              <li v-for="(item,i) in note.featureNotes" :key="'f-'+i" class="note-values">
                • {{ item }}
              </li>
            </ul>
          </div>

          <div class="section" v-if="note.updateNotes.length">
            <div class="section-header">
              <img
                  class="icon"
                  src="@/assets/images/icons/evolution.svg"
                  alt="EVOLUTION"
              />
              <span class="section-title">Évolutions</span>
            </div>
            <ul class="section-content">
              <li v-for="(item,i) in note.updateNotes" :key="'u-'+i" class="note-values">
                • {{ item }}
              </li>
            </ul>
          </div>

          <div class="section" v-if="note.fixNotes.length">
            <div class="section-header">
              <img
                  class="icon"
                  src="@/assets/images/icons/patch.svg"
                  alt="PATCH"
              />
              <span class="section-title">Correctifs</span>
            </div>
            <ul class="section-content">
              <li v-for="(item,i) in note.fixNotes" :key="'c-'+i" class="note-values">
                • {{ item }}
              </li>
            </ul>
          </div>
          </div>
        </div>
      </div>

      <div class="popup-footer">
        <button class="giga-btn small " @click="$emit('close')">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import releaseService from "./service/release.service";

export default {
  name: 'ReleaseNote',

  data() {
    return {
      note: {
        version: '',
        date: '',
        featureNotes: [],
        updateNotes: [],
        fixNotes: []
      }
    }
  },

  async created() {
    try {
      const data = await releaseService.getReleaseNotes()
      this.note = data
    } catch (err) {
      console.error('Erreur en récupérant les release notes :', err)
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 60%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #6cbe3e;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  height: auto;
  border-bottom: 0;
  margin-top: 15px;
}
.modal-header h2 {
  margin: 0;
  font-size: 18px;
  color: #143a5a;
}
.modal-header button {
  background: none;
  border: none;
  cursor: pointer;
}
.version-green {
  color: #28c76f;
  margin-left: 4px;
  font-weight: 600;
}

.modal-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px 30px;
}

.news {
  display: flex;
  align-items: center;
  padding: 5px 16px;
  font-size: 20px;
  font-weight: 600;
  color: #143a5a;
  border-radius: 4px;
  margin-bottom: 16px;
  background: linear-gradient(to right, #f5f7f9, #ffffff);
}
.news-icon {
  width: 30px;
  height: 40px;
  margin-right: 8px;
}

.border-gradient {
  margin: 0;
  padding: 1px;
  background: linear-gradient(139deg, #143a5a, #6cbe3e);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.frame-content {
  background: #f2f4f8;
  border-radius: 8px;
  padding: 20px 30px;
  max-height: 45vh;
  overflow-y: auto;
}
.release-header {
  display: flex;
  align-items: flex-start;
  gap: 100px;
  margin-bottom: 20px;
  background: #fff;
  padding: 3px 14px;
  border-radius: 4px;
}

.release-left {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #143a5a;
  font-weight: 500;
}

.release-date {
  justify-self: end;
  font-size: 12px;
  color: #9ca3af;
  white-space: nowrap;
}

.release-header .giga-release,
.release-header .release-val {
  font-size: 14px;
  color: #143a5a;
}
.release-header .release-val {
  font-weight: 600;
}
.release-header .release-date {
  font-size: 12px;
  color: #9ca3af;
}

.section {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.section + .section {
  margin-top: 20px;
}
.section-header {
  display: flex;
  align-items: center;
  min-width: 200px;
  padding-top: 2px;
}
.section-header .icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.section-title {
  font-weight: 500;
  font-size: 12px;
  color: #143a5a;
}

.section-content {
  flex: 1;
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
  line-height: 21px;
}
.section-content .note-values {
  margin-bottom: 6px;
  font-size: 12px;
  color: #143a5a;
}
.giga-page_header {
  margin-bottom: 0 !important;
}
.popup-footer {
  background: #f5f7fb;
  padding: 15px 30px;
  text-align: right;
}
.giga-btn.small {
  background-color: #6cbe3e;
  color: #fff;
  border: none;
  padding: 6px 25px;
  border-radius: 6px;
  cursor: pointer;
}
</style>
